import { create } from 'zustand'

export const useIsSpinning = create<boolean>(() => false)
